import { render, staticRenderFns } from "./SideList.vue?vue&type=template&id=6f34bbea&"
import script from "./SideList.vue?vue&type=script&lang=js&"
export * from "./SideList.vue?vue&type=script&lang=js&"
import style0 from "./SideList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports